import { Badge } from '@/components/base/badge'

interface Props {
  pass: boolean
}

export const ResultBadge = ({ pass }: Props) => {
  return <Badge color={ pass ? "green" : "red" }> { pass ? "Pass" : "Fail" }</Badge>
}
